//ENUM COM AS VISÕES DA ABERTURA DA POSIÇÃO DOS ATIVOS
//TODO: NOVOS ITEM DEVEM RESPEITAR A NUMERAÇÃO BINÁRIA SEGUINDO A SEQUENCIA DO 'id' COM 2,4,8,16,32,64,128
//A abertura dos fundos ganha o valor 255 que significa que aquele registro é considera para todos
//Caso um determinado fundo não deve ser aberto para uma visão específica, como uma EFPC, o valor 255 deve ser reduzido do 1(EFPC.id), ficando 254
const ABERTURA_VISOES = {
    GERAL: { id: 255, descricao: 'Integral' }, //SOMATÓRIO DE TODOS ENUMS
    EFPC: { id: 1, descricao: 'EFPC' }
};

module.exports = ABERTURA_VISOES;
